import { createAsyncThunk, createAction } from "@reduxjs/toolkit";
import type { Dependencies } from "@redux/store";
import type { UpdateTeacherPublicProfileBody } from "@shared-kernel/application/ports/teacher/teacher-repository";

export const updateTeacherPublicProfile = createAsyncThunk<void, UpdateTeacherPublicProfileBody, { extra: Partial<Dependencies> }>(
  "teachers/updateTeacherPublicProfile",
  async (body, { extra: { teacherRepository } }) => {
    return teacherRepository!.updatePublicProfile(body);
  },
);

export const resetUpdateTeacherPublicProfile = createAction("teachers/resetUpdateTeacherPublicProfile");
